import { useState } from "react";
import PageHeader from "../../components/AdminSideComponents/common/PageHeader";
import Carrier from "../../components/AdminSideComponents/carriers/Carrier";
import CarrierInquiry from "../../components/AdminSideComponents/carriers/CarrierInquiry";

const AdminCarrier = () => {
  const [activeTab, setActiveTab] = useState("carrier");

  return (
    <div className="p-6">
      {/* PAGE HEADER WITH TABS */}
      <PageHeader
        title="Carrier"
        breadcrumb="Dashboard / Carriers"
        customSection={
          <div className="flex gap-4">
            <button
              onClick={() => setActiveTab("carrier")}
              className={`pb-2 px-4 font-medium ${
                activeTab === "carrier"
                  ? "border-b-2 border-pink-500 text-pink-500"
                  : "text-gray-500"
              }`}
            >
              Carrier
            </button>

            <button
              onClick={() => setActiveTab("inquiry")}
              className={`pb-2 px-4 font-medium ${
                activeTab === "inquiry"
                  ? "border-b-2 border-pink-500 text-pink-500"
                  : "text-gray-500"
              }`}
            >
              Carrier Inquiry
            </button>
          </div>
        }
      />

      {/* TAB CONTENT */}
      <div className="mt-6">
        {activeTab === "carrier" && <Carrier />}
        {activeTab === "inquiry" && <CarrierInquiry />}
      </div>
    </div>
  );
};

export default AdminCarrier;
